import { useRef, forwardRef, useImperativeHandle, useCallback } from "react";
import { CheckBox } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const AssigneeCheckBox = forwardRef(
  ({ change, initialValue, id }, ref) => {
    const { t } = useTranslation(["CreateTaskModal"]);
    const componentRef = useRef(null);

    const getValue = useCallback(() => {
      return componentRef.current.checked;
    }, [componentRef]);

    const setValue = useCallback((value) => {
      componentRef.current.checked = value;
    }, []);

    useImperativeHandle(
      ref,
      () => ({
        getValue,
        setValue,
      }),
      [getValue, setValue]
    );

    return (
      <CheckBox
        ref={componentRef}
        id={id}
        checked={initialValue}
        label={t("AssignToMe")}
        change={change}
      />
    );
  }
);
